export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_03.c775ee92.jpg";